import { Box, ButtonBase, Container, Paper, Typography } from '@mui/material'
import React, { useState } from 'react'
import GridMultiFinish from '../../assets/png/grid-multifinish.png'
import WallPaper1 from '../../assets/png/wallpaper-stucco-rough-6141.png'
import WallPaper2 from '../../assets/png/wallpaper-polyhaven-wood.png'
import WallPaper3 from '../../assets/png/wallpaper-vinyl-siding.png'
import WallPaper4 from '../../assets/png/wallpaper-ashland-slate.png'

const GarageMultiFinish = (props) => {

  const [selectedMultiFinish, setSelectedMultiFinish] = useState(null);

  const wallpapers = [
    {
      id: 1,
      image: WallPaper1,
    },
    {
      id: 2,
      image: WallPaper2,
    },
    {
      id: 3,
      image: WallPaper3,
    },
    {
      id: 4,
      image: WallPaper4,
    },
  ]

  return (
    <>
      {/* Grid 1 */}
      <Container>
        <Box sx={{ alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "space-between",}}>
          <Box sx={{display: "flex", flex: 1, justifyContent: "center", p: 5,}}>
            <Paper
              sx={{
                minWidth: 350,
                maxWidth: 500,
                height: 350,
                display: "flex",
                flex: 1,
                alignItems: "flex-end",
                justifyContent: "center",
                backgroundImage: `url(${selectedMultiFinish?.image})`,
                backgroundPosition: "50% 50%",
                backgroundSize: selectedMultiFinish?.id === 3 ? '50%' : '25%',
                borderRadius: 2,
                backgroundRepeat: 'repeat',
              }}
            >
              <Box component="img" src={GridMultiFinish} width="100%" sx={{borderRadius: 1,}}></Box>
            </Paper>
          </Box>
          <Box sx={{display: "flex", flex: 1, justifyContent: "center", minWidth: 350, p: 5,}}>
            <Box sx={{display: "flex", alignItems: "center", }}>
              <Box sx={{display: "flex", flexDirection: "column", mr: 2}}>
                {
                  wallpapers.map(wallpaper => (
                    <ButtonBase key={wallpaper.id} onClick={() => {setSelectedMultiFinish(wallpaper)}} sx={{ borderRadius: 1, m:1,}}>
                      <Paper
                        sx={{
                          width: 40,
                          height: 40,
                          backgroundImage: `url(${wallpaper.image})`,
                          backgroundPosition: "50% 50%",
                          backgroundSize: 'cover',
                          borderRadius: 2,
                          backgroundRepeat: 'repeat',
                        }}
                      >
                      </Paper>
                    </ButtonBase>
                  ))
                }
              </Box>
              <Box>
                <Typography component="h2" variant="h2" fontSize={40} fontWeight={600}>MultiFinish.</Typography>
                <Typography width={350}>Test out different wall and floor finishes to get the look that matches your taste. See concrete finishes or resilient flooring options.</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      {/* Grid 2 */}
    </>
  )
}

export default GarageMultiFinish